import { render, staticRenderFns } from "./zdyrbhanjie.vue?vue&type=template&id=2a6bfe2f&scoped=true&"
import script from "./zdyrbhanjie.vue?vue&type=script&lang=js&"
export * from "./zdyrbhanjie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6bfe2f",
  null
  
)

export default component.exports